export default {
  latestRecognition: {
    title: 'Seneste anerkendelser',
    result: 'Resultat:',
    danmarksBilligste: 'Skarp pris',
    januar2026: 'Januar 2026',
    testOf14: 'Test af 14 udbydere',
    cheapestSolution: 'billigste ladeløsning',
    nicolaskjText1: 'Enkel Energi placeres som',
    nicolaskjText2: 'elselskab i uafhængig analyse uden affiliatelinks.',
    elbiilText1: 'Enkel Energi kåret som',
    elbiilText2: 'i Danmark - laveste pris på el og service.',
  },
  stromligningScoreTitle: 'Strømligning Score',
  stromligningRating: 'Enkel Energi er bedømt til {score} ud af 5 stjerner',
  stromligningCertifiedTitle: 'Certificeret af Strømligning',
  stromligningCertifiedText: 'Enkel Energi har forpligtet sig til at følge Strømlignings kodeks for god skik, overholde dansk lovgivning og deltage i uvarslede kontroller.',
  review1Name: 'Michael Rasmussen',
  review2Name: 'Mikkel Andreasen',
  review3Name: 'Thomas Hansen',
  heroTitle1: 'Smart for økonomien,',
  heroTitle2: 'enkelt i hverdagen',
  heroSubtitle: 'Vi tjener på elhandel, ikke på dig.',
  heroNote: '*Du kan også bruge enkel energi som dit normale elselskab – ',
  heroNoteHighlight: 'helt uden elbil',
  heroFootnote: '* Bemærk: Hertil kommer lovpligtige elafgifter og transportbetaling til netselskabet. Serviceaftale gælder for Easee, NexBlue og Zaptec ladebokse.',

  // CTA Cards
  elAftaleTitle: 'Elaftale',
  elAftalePriceFrom: 'El fra 0,72 kr./kWh',
  elAftalePriceContext: 'Elhandler-pris ekskl. net, afgifter og moms',
  elAftaleNoMarkup: 'Ingen tillæg til spotprisen',
  elAftaleFreeApp: 'Saving Mode app inkluderet',
  seeElAftaler: 'Se elaftaler',

  ladeboksTitle: 'Ladeboks + El',
  ladeboksComplete: 'Komplet pakke',
  ladeboksPriceFrom: 'Ladebokse fra 3.999 kr.',
  ladeboksPriceContext: 'El fra 0,72 kr./kWh (elhandler-pris)',
  ladeboksSmartCharge: 'Saving Mode fra dag ét',
  ladeboksFreeService: 'Serviceaftale inkluderet',
  elIncluded: 'Elaftale inkluderet',
  seeLadepakker: 'Se ladepakker',

  // Save 30% Banner
  saveBannerTitle: 'Spar op til 30% på din ladning*',
  saveBannerSubtitle: 'Saving Mode giver dig prisgaranti – du betaler altid for de billigste timer i din ladeperiode. Inkluderet for alle vores kunder',
  saveBannerCTA: 'Sådan virker det',
  saveBannerNote: '*Beregnet besparelse i forhold til almindelig opladning uden styring. Analyse baseret på elpriser fra juli 2025.',

  // Why enkel
  whyEnkelTitle: 'Hvorfor skifte til',
  whyEnkelTitleHighlight: 'enk',
  whyEnkelTitleEnd: 'el?',
  whyEnkelSubtitle: 'Skift til nyt elselskab med gennemsigtige priser. Ingen tricks, bare ærlig el. Skift eludbyder nemt\u00A0online.',

  benefit1Title: 'Spotpris 1:1 uden tillæg',
  benefit1Text: 'Vi videreformidler spotprisen 1:1 uden tillæg.*',
  benefit2Title: 'Ingen binding',
  benefit2Text: 'Skift når det passer dig. Vi beholder kunder ved at være gode – ikke med bindinger.',
  benefit3Title: 'Alt inkluderet uden tillæg',
  benefit3Text: 'Saving Mode app, serviceaftale og betalingsservice (0 kr.) – alt er med i prisen du ser.',
  benefit4Title: 'Solcelleaftale uden gebyr',
  benefit4Text: 'Danmarks eneste solcelleaftale uden\u00A0leverandørgebyrer.',

  // 2026 context box
  context2026Title: 'El-refusionen er nu forsvundet',
  context2026Text: 'Men prisen på el er ikke blevet enklere – mange selskaber lægger ekstra tillæg ind i fakturaen i stedet. Vi gør det modsatte: ingen refusionstricks, ingen tillæg – bare fair pris fra dag\u00A0ét. Har du elbil? Det er måske på tide at få din egen ladeboks og spare endnu mere med Saving Mode.',

  // Pie chart savings comparison
  pieSavings: {
    title: 'Spar penge på dit elforbrug',
    subline: 'Sammenlign med markedet – de fleste tager tillæg ovenpå spotprisen.',
    sublineExtra: 'Enkelte udbydere bygger tillægget ind i fakturaen*',
    leftTitle: 'Typisk elselskab',
    leftCaption: 'Tillæg og abonnement indregnet i prisen.',
    rightTitle: 'Hos enkel energi',
    rightCaption: 'Ingen tillæg. Kun lavt abonnement.',
    savingsPercent: 'Spar 18%',
    savingsSubtitle: 'på dit elforbrug',
    ctaButton: 'Beregn din egen besparelse',
    footnoteText: 'Vil du se hvordan vi beregner prisen?',
    footnoteLink: 'Læs forklaringen her',
  },

  // AI App Section
  aiAppBadge: 'Inkluderet for alle kunder',
  aiAppTitle: 'Prisgaranti på opladning',
  aiAppDescription: 'Med Saving Mode betaler du altid for de billigste timer i din ladeperiode. Sæt din afgangstid og ønskede batteriniveau – så klarer vi resten.',
  aiAppFeature1Title: 'Prisgaranti på opladning',
  aiAppFeature1Text: 'Du betaler altid for de billigste timer i din ladeperiode',
  aiAppFeature2Title: 'Altid klar til afgang',
  aiAppFeature2Text: 'Sæt en mål-% og afgangstid – vi klarer resten',
  aiAppFeature3Title: 'Nemt overblik',
  aiAppFeature3Text: 'Se dit forbrug og dine tidligere opladninger i appen',

  // Solar Section
  solarBadge: '0 KR. LEVERANDØRGEBYR',
  solarTitle: 'Har du solceller? Få produktionsaftale uden leverandørgebyr',
  solarDescription: 'Hos enkel får du en produktionsaftale til dine solceller uden leverandørgebyrer. Vi betaler dig markedspris minus lovpligtige omkostninger og transportgebyrer.',
  solarBenefit1: '0 kr. i leverandørgebyr',
  solarBenefit2: 'Markedspris minus lovpligtige omkostninger',
  solarBenefit3: '0 kr. i leverandørgebyr hos enkel',
  seeSolarAftale: 'Se solcelleaftale',

  // Comparison Section
  comparisonTitle: 'Vi er ikke som andre elselskaber',
  comparisonSubtitle: 'De fleste elselskaber tjener penge på at lægge tillæg på din el.',
  comparisonClarification: 'Med Enkel Energi får du spotpris 1:1 – uden tillæg. Sammenlign os med andre udbydere på stromligning.dk og spar over 50% på dit årlige forbrug.',
  comparisonChartTitle: 'Månedlige abonnementspriser (ifølge ELBIIL.dk test)',
  comparisonSource: 'Kilde:',
  comparisonSourceLink: 'ELBIIL.dk uafhængig test af 14 udbydere',

  others1: 'Tillæg på typisk 2,5–13 øre/kWh (nogle helt op til 30 øre/kWh)',
  others2: 'Høje abonnementer (22-164 kr./md)',
  others3: 'Tillæg indregnet i prisen, ofte med binding',
  others4: 'Saving Mode koster ekstra',

  enkelTitle: 'enkel energi',
  enkel1: 'Fra 0 øre/kWh tillæg til spotprisen',
  enkel2: 'Fra kun 18 kr./md i abonnement',
  enkel3: 'Ingen binding',
  enkel4: 'Saving Mode app inkluderet',

  // Stromligning badges
  stromligningScoreTitle: 'Strømligning Score',
  stromligningRating: 'Enkel Energi er bedømt til {score} ud af 5 stjerner.',
  stromligningCertifiedTitle: 'Certificeret af Strømligning',
  stromligningCertifiedText: 'Enkel Energi har forpligtet sig til at følge Strømlignings kodeks for god skik, overholde dansk lovgivning og deltage i uvarslede kontroller.',

  // Price comparison chart companies
  enkelEnergiCompany: 'enkel energi',
  enkelEnergiPrice: '28 kr.',
  ewiiCompany: 'EWII',
  ewiiPrice: '54 kr.',
  okCompany: 'OK',
  okPrice: '105 kr.',
  norlysCompany: 'Norlys',
  norlysPrice: '150 kr.',
  andelCompany: 'Andel',
  andelPrice: '164 kr.',

  // Process
  processTitle: 'Skift elselskab på 2 minutter',
  processSubtitle: 'Vi håndterer alt det praktiske – skift strømleverandør nemt og hurtigt online',
  step1Title: 'Vælg din nye elaftale',
  step1Text: 'El, ladeboks eller begge dele. Du\u00A0bestemmer.',
  step2Title: 'Udfyld dine oplysninger',
  step2Text: 'Vi har brug for få oplysninger for at skifte dig til ny el-leverandør.',
  step3Title: 'Vi klarer resten',
  step3Text: 'Vi opsiger hos dit gamle selskab og starter din nye aftale – du behøver ikke gøre mere.',
  processButton: 'Skift elselskab nu',

  // FAQ
  faqTitle: 'Ofte stillede spørgsmål om skift af elselskab',
  faq1Q: 'Hvor lang tid tager det at skifte elselskab?',
  faq1A: 'Selve tilmeldingen tager 2 minutter online. Skiftet til ny el-leverandør træder typisk i kraft inden for få\u00A0dage.',
  faq2Q: 'Skal jeg selv opsige hos mit nuværende elselskab?',
  faq2A: 'Nej, vi håndterer skift af strømleverandør for dig – du behøver ikke kontakte dit gamle\u00A0selskab.',
  faq3Q: 'Kan alle skifte til enkel energi?',
  faq3A: 'Ja! Du behøver ikke have en elbil. Vi leverer strøm til alle danske husstande. Skift elselskab nemt\u00A0online.',
  faq4Q: 'Virker Saving Mode med min ladeboks?',
  faq4A: 'Ja, vi understøtter alle ladebokse fra Zaptec, NexBlue og\u00A0Easee.',
  seeAllQuestions: 'Se alle spørgsmål →',
  seeAllQuestionsArrow: '→',
  
  // Review names and controls
  showLess: 'Vis mindre',
  readFullReviews: 'Læs hele anmeldelserne',

  // Final CTA
  finalCtaTitle: 'Klar til at skifte til nyt elselskab?',
  finalCtaSubtitle: 'Skift elaftale i dag og spar penge på din strøm. Vi gør det nemt at skifte strøm – på under 2 minutter.',
};